import accountCircleIcon from '/img/account_circle.svg'
import articleIcon from '/img/article.svg'
import fileSaveOffIcon from '/img/file_save_off.svg'
import inHomeModeIcon from '/img/in_home_mode.svg'
import verifiedIcon from '/img/verified.svg'
import { Button } from '#app/components/ui/button'
import { Icon } from '#app/components/ui/icon.js'
export default function HowItWorksRoute() {
	return (
		<div className="w-full min-h-screen overflow-hidden">
			<section className="py-12 sm:py-16 lg:py-24">
				<div className="px-[15px] md:px-[100px] mx-auto">
					{/* Header Section */}
					<div className="text-center">
						<h1 className="text-3xl md:text-5xl lg:text-6xl font-normal text-neutral-800 mb-6 font-['Futura_Hv_BT']">
							How It Works?
						</h1>
						<p className="text-lg md:text-xl lg:text-2xl text-neutral-600 max-w-5xl mx-auto leading-relaxed font-['Futura_Bk_BT']">
							Renting should be simple. With TrueTenant, you complete one secure
							application and <br />
							create a verified profile you can use for any property in our
							network.
						</p>
					</div>

					{/* Flow Introduction */}
					<div className="mt-14 mb-14">
						<h2 className="text-2xl sm:text-3xl lg:text-4xl font-normal text-neutral-800 mb-8 font-['Futura_Md_BT'] text-left">
							5-Step Flow – Please display each step as a tile/card with an
							icon:
						</h2>
					</div>

					{/* 5-Step Process */}
					<div className="space-y-0 sm:space-y-0">
						{/* Step 1 */}
						<div className="p-4 sm:p-10 border-b border-gray-200">
							<div className="flex flex-col sm:flex-row items-start gap-4 sm:gap-6 mb-4">
								<div className="flex-shrink-0">
									<div className="h-8  rounded-full flex items-center justify-center">
										<img
											src={accountCircleIcon}
											alt="Account Circle"
											className="w-6 h-6"
										/>
									</div>
								</div>
								<div className="flex-1">
									<h3 className="text-xl sm:text-2xl font-['Futura_Md_BT'] text-neutral-800 mb-2">
										Step 1: Create Your Profile
									</h3>
								</div>
							</div>
							<p className="text-sm sm:text-base lg:text-lg text-neutral-600 font-['Futura_Bk_BT']">
								Sign up, add your basic details, and start building your rental
								profile in minutes.
							</p>
						</div>

						{/* Step 2 */}
						<div className="p-4 sm:p-10 border-b border-gray-200">
							<div className="flex flex-col sm:flex-row items-start gap-4 sm:gap-6 mb-4">
								<div className="flex-shrink-0">
									<div className="h-8  rounded-full flex items-center justify-center">
										<img
											src={verifiedIcon}
											alt="Verified"
											className="w-6 h-6"
										/>
									</div>
								</div>
								<div className="flex-1">
									<h3 className="text-xl sm:text-2xl font-['Futura_Md_BT'] text-neutral-800 mb-2">
										Step 2: Verify Your Identity & Income
									</h3>
								</div>
							</div>
							<p className="text-sm sm:text-base lg:text-lg text-neutral-600 font-['Futura_Bk_BT']">
								Confirm your identity with a government ID and securely verify
								your income through a quick check — no extra paperwork required.
							</p>
						</div>

						{/* Step 3 */}
						<div className="p-4 sm:p-10 border-b border-gray-200">
							<div className="flex flex-col sm:flex-row items-start gap-4 sm:gap-6 mb-4">
								<div className="flex-shrink-0">
									<div className="h-8  rounded-full flex items-center justify-center">
										<img
											src={articleIcon}
											alt="File Save Off"
											className="w-6 h-6"
										/>
									</div>
								</div>
								<div className="flex-1">
									<h3 className="text-xl sm:text-2xl font-['Futura_Md_BT'] text-neutral-800 mb-2">
										Step 3: Share Your Rental History
									</h3>
								</div>
							</div>
							<p className="text-sm sm:text-base lg:text-lg text-neutral-600 font-['Futura_Bk_BT']">
								Answer a few quick questions about your current or past
								residences to complete your profile.
							</p>
						</div>

						{/* Step 4 */}
						<div className="p-4 sm:p-10 border-b border-gray-200">
							<div className="flex flex-col sm:flex-row items-start gap-4 sm:gap-6 mb-4">
								<div className="flex-shrink-0">
									<div className="h-8  rounded-full flex items-center justify-center">
										<img
											src={inHomeModeIcon}
											alt="In Home Mode"
											className="w-6 h-6"
										/>
									</div>
								</div>
								<div className="flex-1">
									<h3 className="text-xl sm:text-2xl font-['Futura_Md_BT'] text-neutral-800 mb-2">
										Step 4: See Eligible Rentals Instantly
									</h3>
								</div>
							</div>
							<p className="text-sm sm:text-base lg:text-lg text-neutral-600 font-['Futura_Bk_BT']">
								Once your profile is created, you'll immediately see rentals you
								qualify for.
							</p>
						</div>

						{/* Step 5 */}
						<div className="p-4 sm:p-10 border-b border-gray-200">
							<div className="flex flex-col sm:flex-row items-start gap-4 sm:gap-6 mb-4">
								<div className="flex-shrink-0">
									<div className="h-8  rounded-full flex items-center justify-center">
										<img
											src={fileSaveOffIcon}
											alt="Article"
											className="w-6 h-6"
										/>
									</div>
								</div>
								<div className="flex-1">
									<h3 className="text-xl sm:text-2xl font-['Futura_Md_BT'] text-neutral-800 mb-2">
										Step 5: Never Fill Out An Application Again
									</h3>
								</div>
							</div>
							<p className="text-sm sm:text-base lg:text-lg text-neutral-600 font-['Futura_Bk_BT']">
								Your profile is reusable — apply anywhere on TrueTenant with
								just one click.
							</p>
						</div>
					</div>

					{/* Call to Action Button */}
					<div className="text-center mt-12">
						<Button
							asChild
							size="lg"
							className="sm:w-auto w-fit rounded-[47.80px] text-xl font-normal font-['Futura_Md_BT'] tracking-wider"
						>
							<a
								href="/signup"
								className="flex items-center justify-center gap-4"
							>
								<div className="text-center justify-center text-white text-l font-normal font-['Futura_Md_BT']">
									Start Verification
								</div>
								<Icon name="arrow-right" className="w-6 h-6" />
							</a>
						</Button>
					</div>
				</div>
			</section>
		</div>
	)
}
